import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import axios from "axios"
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import less from 'less'
import './static/icon/iconfont.css'
import './static/js/flexible'
import Print from '../src/static/js/print' // 引入附件的js文件
import "../src/assets/style/table_style.css";
Vue.use(Print) // 注册
Vue.config.productionTip = false
Vue.prototype.axios = axios
Vue.prototype.bus = new Vue;
Vue.use(ElementUI,less);

// 全局前置守卫
router.beforeEach((to, from, next) => {
  // 这里假设用户已经通过某种方式存储在Vuex或localStorage中
  const isUserLoggedIn = sessionStorage.getItem('token')  /* 判断用户是否登录的逻辑 */
 
  if (!isUserLoggedIn && to.path !== '/') {
    // 如果用户没有登录并且不是访问登录页，则重定向到登录页
    next('/');
  } else {
    // 否则，继续正常的路由导航
    next();
  }
});

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
